export default "Nu skal I lave jeres eget tegnekul af løvgrene og bruge det fx til at lave magiske hulemalerier med!";